import EnrichmentIcon from "assets/icons/EnrichmentIcon";
import classNames from "classnames";
import styles from "./style.module.scss";
import { connect } from "react-redux";
import { State } from "redux/store";
import { RefObject } from "react";
import { getIsEnrichmentTabEnabled } from "redux/SingleDataset/selectors";
import teaserBGImage from "assets/pngImages/enrichment-teaser.png";

interface EnrichmentTeaserboxTypes {
  isEnrichmentEnabled: boolean;
  onTryEnrichmentClick: () => void;
  vlEnrichmentRef: RefObject<HTMLDivElement>;
}

const EnrichmentTeaser = ({
  vlEnrichmentRef,
  isEnrichmentEnabled,
  onTryEnrichmentClick,
}: EnrichmentTeaserboxTypes) => {
  const teaserMessage = isEnrichmentEnabled ? (
    <>
      Enrich your data using VL <br /> proprietary or foundation AI models
    </>
  ) : (
    "Ask the Dataset owner to enrich this Dataset with proprietary or foundation AI models"
  );
  return (
    <div className={styles.enrichmentTeaser} ref={vlEnrichmentRef}>
      <div className={styles.teaserBGImage}>
        <img src={teaserBGImage} alt="Enrichment Teaser" />
      </div>
      <div className={styles.container}>
        <div className={styles.TitleContainer}>
          <div className={styles.titleIcon}>
            <EnrichmentIcon />
          </div>
          <div className={styles.titleText}>Enrichment Models</div>
        </div>
        <div className={styles.body}>
          <div
            className={classNames(styles.messageContainer, {
              [styles.extraMargin]: !isEnrichmentEnabled,
            })}
          >
            {teaserMessage}
          </div>
          {isEnrichmentEnabled && (
            <div
              className={styles.contactUsButton}
              onClick={onTryEnrichmentClick}
            >
              TRY ENRICHMENT
            </div>
          )}
        </div>
      </div>
    </div>
  );
};

const mapStateToProps = (state: State) => {
  return {
    isEnrichmentEnabled: getIsEnrichmentTabEnabled(state),
  };
};

export default connect(mapStateToProps)(EnrichmentTeaser);
